import React from 'react';
import { MimaText, NewModal } from '../../components';
import { amountFormatter } from '../../utils/utils';

const ViewPlansModal = ({ closeModal, currentPlan }) => {
	return (
		<NewModal closeModal={closeModal}>
			<MimaText variant="subtitleBold" align="center" mb={2}>
				Plan Details
			</MimaText>
			<div style={{ width: '100%' }}>
				<MimaText labelTitle="Name" mb={2}>
					{currentPlan?.name}
				</MimaText>
				<MimaText labelTitle="Cycle" mb={2}>
					{currentPlan?.cycle}
				</MimaText>
				<MimaText labelTitle="Interval" mb={2}>
					{currentPlan?.interval}
				</MimaText>
				<MimaText labelTitle="Price" mb={2}>
					{amountFormatter(currentPlan?.currencyCode).format(
						currentPlan?.amount
					)}
				</MimaText>
				<MimaText labelTitle="Trial period in days" mb={2}>
					{currentPlan?.trialPeriod === 0
						? 'No trial'
						: currentPlan?.trialPeriod}
				</MimaText>
				{currentPlan?.activateUrl ? (
					<MimaText labelTitle="Activate Webhook" mb={2}>
						{currentPlan?.activateUrl}
					</MimaText>
				) : (
					''
				)}
				{currentPlan?.deActivateUrl ? (
					<MimaText labelTitle="Deactivate Webhook" mb={2}>
						{currentPlan?.deActivateUrl}
					</MimaText>
				) : (
					''
				)}
			</div>
		</NewModal>
	);
};

export default ViewPlansModal;
